export enum ApplicationStatus {
    IDLE,
    LOADING,
    RUNNING,
    FAILED,
}